export function hasSentryReplays(user) {
    return user?.isClinician && user?.owner?.keyValues?.featureFlags?.sentryReplays
}

export function extractFirstLastNames(fullName) {
    if (!fullName || typeof fullName !== 'string') {
        return { firstName: '', lastName: '' }
    }

    const parts = fullName.split(' ')
    const firstName = parts.shift() || ''
    const lastName = parts.join(' ')

    return { firstName, lastName }
}
